export default __webpack_public_path__ + "static/media/img7.659ab3b9.png";